import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Logo } from '../components/Logo';
import './legal.css';

interface LegalLayoutProps {
  kicker: string;
  title: string;
  lastUpdated: string;
  intro: string;
  documentTitle: string;
  children: React.ReactNode;
}

const BrandLogo: React.FC = () => (
  <span className="legal-nav__logo" aria-hidden="true">
    <Logo size={36} />
  </span>
);

export const LegalLayout: React.FC<LegalLayoutProps> = ({
  kicker,
  title,
  lastUpdated,
  intro,
  documentTitle,
  children,
}) => {
  useEffect(() => {
    const previous = document.title;
    document.title = documentTitle;
    return () => {
      document.title = previous;
    };
  }, [documentTitle]);

  return (
    <div className="legal-page">
      <header className="legal-nav">
        <Link to="/" className="legal-nav__brand">
          <BrandLogo />
          <span className="legal-nav__brand-text">PaperBrain</span>
        </Link>

        <div className="legal-nav__cta">
          <Link to="/login" className="legal-nav__quiet">
            Sign in
          </Link>
          <Link to="/register" className="legal-nav__btn">
            Make my notes searchable
          </Link>
        </div>
      </header>

      <main>
        <article className="legal-article">
          <header>
            <span className="legal-kicker">{kicker}</span>
            <h1 className="legal-title">{title}</h1>
            <p className="legal-updated">Last updated: {lastUpdated}</p>
          </header>

          <p className="legal-intro">{intro}</p>

          {children}

          <Link to="/" className="legal-back">
            ← Back to the landing page
          </Link>
        </article>
      </main>

      <footer className="legal-footer">
        <div className="legal-footer__inner">
          <span>© 2026 Byte-Sized Bits, LLC · PaperBrain — handwritten knowledge, indexed.</span>
          <div className="legal-footer__links">
            <Link to="/pricing">Pricing</Link>
            <Link to="/privacy">Privacy</Link>
            <Link to="/terms">Terms</Link>
            <Link to="/refunds">Refunds</Link>
            <a href="mailto:hello@bytesizedbits.com">hello@bytesizedbits.com</a>
          </div>
        </div>
      </footer>
    </div>
  );
};
